export default __webpack_public_path__ + "static/media/heart.33a3b6ab.svg";